import React from 'react';
import classNames from 'classnames';
import { cloudinaryImageUrl, ratioOptions } from '@scentregroup/ui/tools/cloudinary/image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const Image = _ref => {
  let {
    className,
    imageUrl,
    ratio,
    alt,
    bgSize,
    dataTestId
  } = _ref;
  if (!imageUrl) {
    return /*#__PURE__*/_jsx("div", {
      className: className,
      "data-id": "image_index_Image_div",
      children: /*#__PURE__*/_jsx("div", {
        className: classNames(style.placeholder, style[ratio]),
        "data-id": "image_index_Image_div_div_1"
      })
    });
  }
  return /*#__PURE__*/_jsx("img", {
    className: className,
    "data-test-id": dataTestId,
    src: cloudinaryImageUrl({
      src: imageUrl,
      ratio,
      numberofItems: 1,
      bgSize
    }),
    alt: alt,
    "data-id": "image_index_Image_img"
  });
};
Image.defaultProps = {
  alt: ''
};
export default Image;